import React from 'react';

import { If } from 'utils';
import { PageErrorUi, UiKit } from 'components';
import Loader from '../Loader';
import ProductVariants from './ProductVariants';
import ProductTypes from './ProductTypes';
import * as ProductReturnWindowDelete from '../../ProductReturnWindowDelete';
import { useProductReturnWindowConfig } from '../context';

export default function Form() {
  const {
    windowId,
    mode,
    data,
    isError,
    isLoading,
    errors,
    onLoad,
    onChange,
    isFormOpen,
    isProcessing,
    onCloseForm,
    onSave,
    onSaved,
    selectedType
  } = useProductReturnWindowConfig();

  const handleDeleted = () => {
    onCloseForm();
    onSaved();
  };

  const confirmButtonText = mode === 'edit' ? 'Save' : 'Create';
  const selectedProductsCount = data.products?.length || 0;
  const selectedVariantsCount = data.product_variants?.length || 0;
  const selectedProductTypesCount = data.product_types?.length || 0;

  const modalTitle = `Product ${selectedType === 'SKU' ? 'SKU' : 'Type'}`;
  const title = `${mode === 'edit' ? 'Edit' : 'Create'} Custom Return Window`;
  const subTitle = `Customize return windows based on product ${
    selectedType === 'SKU' ? 'SKU' : 'type'
  }.`;

  return (
    <UiKit.Modal
      size="md"
      isOpen={isFormOpen}
      onClose={onCloseForm}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title={modalTitle} />
      <UiKit.Modal.Body>
        <UiKit.Flex direction="column" gap={24} className="w-100">
          <UiKit.Flex direction="column" gap={4}>
            <UiKit.Title weight="normal">{title}</UiKit.Title>
            <UiKit.Text variant={500}>{subTitle}</UiKit.Text>
          </UiKit.Flex>
          <PageErrorUi
            isError={isError}
            onReload={onLoad}
            msg="Unable to load the SKU Return Window  data at the moment!"
          >
            <Loader>
              <UiKit.Input
                label="Name"
                placeholder="Enter custom return window name"
                value={data.name}
                onChange={name => onChange({ name })}
                disabled={isProcessing}
                error={errors.name}
              />
              <UiKit.Input
                autoFocus
                type="number"
                min={1}
                label={
                  <>
                    Return Window&nbsp;
                    <span style={{ color: '#9CA3AF', fontSize: 12 }}>
                      (in days)
                    </span>
                  </>
                }
                value={data.service_days}
                onChange={value => onChange({ service_days: value })}
                placeholder="Enter custom return window"
                disabled={isProcessing}
                error={errors.service_days}
              />
              <UiKit.Separator />
              <If test={selectedType === 'SKU'} otherwise={<ProductTypes />}>
                <ProductVariants />
              </If>
              <UiKit.Flex justify="center">
                <If test={selectedType === 'SKU'}>
                  <If
                    test={!errors.product_variants}
                    otherwise={<UiKit.Error msg={errors.product_variants} />}
                  >
                    <If test={!isLoading && selectedProductsCount > 0}>
                      <UiKit.Text weight="bold">
                        {selectedProductsCount} SKU, {selectedVariantsCount}{' '}
                        {selectedVariantsCount > 1 ? 'variants' : 'variant'}{' '}
                        selected
                      </UiKit.Text>
                    </If>
                  </If>
                </If>
                <If test={selectedType === 'TYPE'}>
                  <If
                    test={!errors.product_types}
                    otherwise={<UiKit.Error msg={errors.product_types} />}
                  >
                    <If test={!isLoading && selectedProductTypesCount > 0}>
                      <UiKit.Text weight="bold">
                        {selectedProductTypesCount} Product{' '}
                        {selectedProductTypesCount > 1 ? 'Types' : 'Type'}{' '}
                        selected
                      </UiKit.Text>
                    </If>
                  </If>
                </If>
              </UiKit.Flex>
            </Loader>
          </PageErrorUi>
        </UiKit.Flex>
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer onConfirm={onSave} confirmBtnText={confirmButtonText}>
        <If test={mode === 'edit'}>
          <ProductReturnWindowDelete.Provider
            windowId={windowId}
            windowType={selectedType}
            onDeleted={handleDeleted}
          >
            <ProductReturnWindowDelete.Trigger />
          </ProductReturnWindowDelete.Provider>
        </If>
      </UiKit.Modal.Footer>
    </UiKit.Modal>
  );
}
